import { useMediaQuery } from "@mui/material";

export const useScreenSize = () => {
  const isExtraSmallScreen = useMediaQuery("only screen and (min-width: 300px)");
  const isSmallScreen = useMediaQuery("only screen and (min-width: 1200px)");
  const isLaptopScreen = useMediaQuery("only screen and (min-width: 1440px)");
  const isLargeScreen = useMediaQuery("only screen and (min-width: 2000px)");
  const isExtraLargeScreen = useMediaQuery("only screen and (min-width: 3301px)");

  return {
    isExtraSmallScreen,
    isSmallScreen,
    isLaptopScreen,
    isLargeScreen,
    isExtraLargeScreen,
  };
};
